export const QuicksightData = {
    mapping : [{
            path: "/app/premium-dashboard/ccr",
            dashboard_id: "5e647e0f-573f-4f75-854b-7e7cd4051ac6"
        }
    ],
    pac_tenantId : "903a42bc-985e-40d1-9c72-32b8c2e33397"
};
